<template>
  <div class="workspace">
    <TopHeader />
    <b-container class="panel">
      <div class="item" @click="func1()">기능1</div>
      <div class="item" @click="func2()">기능2</div>
      <div class="item" @click="func3()">기능3</div>
    </b-container>
  </div>
</template>

<script>
import TopHeader from "@/components/Header";
export default {
  components: { TopHeader },
  methods: {
    func1() {
      this.$router.push("/task1");
    },
    func2() {
      this.$router.push("/task2");
    },
    func3() {
      this.$router.push("/task3");
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.panel {
  //   background-color: red;
  max-width: 800px;
  height: calc(100vh - 60px);
  display: flex;
  justify-content: space-between;
  align-items: center;

  div.item {
    border-radius: 50%;
    width: 150px;
    height: 150px;
    background-color: $gray800;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $gray200;
  }
}
</style>